/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnLoadingIndicatorComponent } from './loading-indicator.component';
var SnLoadingIndicatorModule = /** @class */ (function () {
    function SnLoadingIndicatorModule() {
    }
    /**
     * @return {?}
     */
    SnLoadingIndicatorModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: SnLoadingIndicatorModule
        };
    };
    SnLoadingIndicatorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        SnLoadingIndicatorComponent
                    ],
                    exports: [
                        SnLoadingIndicatorComponent
                    ]
                },] }
    ];
    return SnLoadingIndicatorModule;
}());
export { SnLoadingIndicatorModule };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZGluZy1pbmRpY2F0b3IubW9kdWxlLmpzIiwic291cmNlUm9vdCI6Im5nOi8vQGluc2lnaHQvc2VyZW5pdHktbmd4LyIsInNvdXJjZXMiOlsibGliL2xvYWRpbmctaW5kaWNhdG9yL2xvYWRpbmctaW5kaWNhdG9yLm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsT0FBTyxFQUFFLFFBQVEsRUFBdUIsTUFBTSxlQUFlLENBQUM7QUFDOUQsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRS9DLE9BQU8sRUFBRSwyQkFBMkIsRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBRTVFO0lBQUE7SUFpQkEsQ0FBQzs7OztJQUxpQixnQ0FBTzs7O0lBQXJCO1FBQ0ksT0FBTztZQUNILFFBQVEsRUFBRSx3QkFBd0I7U0FDckMsQ0FBQztJQUNOLENBQUM7O2dCQWhCSixRQUFRLFNBQUM7b0JBQ04sT0FBTyxFQUFFO3dCQUNMLFlBQVk7cUJBQ2Y7b0JBQ0QsWUFBWSxFQUFFO3dCQUNWLDJCQUEyQjtxQkFDOUI7b0JBQ0QsT0FBTyxFQUFFO3dCQUNMLDJCQUEyQjtxQkFDOUI7aUJBQ0o7O0lBT0QsK0JBQUM7Q0FBQSxBQWpCRCxJQWlCQztTQU5ZLHdCQUF3QiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE5nTW9kdWxlLCBNb2R1bGVXaXRoUHJvdmlkZXJzIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG5pbXBvcnQgeyBDb21tb25Nb2R1bGUgfSBmcm9tICdAYW5ndWxhci9jb21tb24nO1xuXG5pbXBvcnQgeyBTbkxvYWRpbmdJbmRpY2F0b3JDb21wb25lbnQgfSBmcm9tICcuL2xvYWRpbmctaW5kaWNhdG9yLmNvbXBvbmVudCc7XG5cbkBOZ01vZHVsZSh7XG4gICAgaW1wb3J0czogW1xuICAgICAgICBDb21tb25Nb2R1bGVcbiAgICBdLFxuICAgIGRlY2xhcmF0aW9uczogW1xuICAgICAgICBTbkxvYWRpbmdJbmRpY2F0b3JDb21wb25lbnRcbiAgICBdLFxuICAgIGV4cG9ydHM6IFtcbiAgICAgICAgU25Mb2FkaW5nSW5kaWNhdG9yQ29tcG9uZW50XG4gICAgXVxufSlcbmV4cG9ydCBjbGFzcyBTbkxvYWRpbmdJbmRpY2F0b3JNb2R1bGUge1xuICAgIHB1YmxpYyBzdGF0aWMgZm9yUm9vdCgpOiBNb2R1bGVXaXRoUHJvdmlkZXJzIHtcbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgIG5nTW9kdWxlOiBTbkxvYWRpbmdJbmRpY2F0b3JNb2R1bGVcbiAgICAgICAgfTtcbiAgICB9XG59XG4iXX0=